module.exports = __webpack_public_path__ + "static/media/a44.c16f2f06.jpg";